{
  "labels": {
    "paste": "අලවන්න",
    "pasteAsPlaintext": "",
    "pasteCharts": "ප්‍රස්ථාරය",
    "selectAll": "සියල්ලම",
    "multiSelect": "තෝරා ගැනීමට අංගය එකතු කරන්න",
    "moveCanvas": "කැන්වසය චලනය කරන්න",
    "cut": "කපන්න",
    "copy": "පිටපත් කරන්න",
    "copyAsPng": "PNG ලෙස පිටපත් කරන්න",
    "copyAsSvg": "SVG ලෙස පිටපත් කරන්න",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "ඉදිරියට ගෙන්න",
    "sendToBack": "පසුපසටම ගෙනියන්න",
    "bringToFront": "ඉදිරියටම ගෙන්න",
    "sendBackward": "පසුපසට ගෙනියන්න",
    "delete": "මකන්න",
    "copyStyles": "",
    "pasteStyles": "",
    "stroke": "",
    "background": "",
    "fill": "",
    "strokeWidth": "",
    "strokeStyle": "",
    "strokeStyle_solid": "",
    "strokeStyle_dashed": "",
    "strokeStyle_dotted": "",
    "sloppiness": "",
    "opacity": "",
    "textAlign": "",
    "edges": "",
    "sharp": "",
    "round": "",
    "arrowheads": "",
    "arrowhead_none": "",
    "arrowhead_arrow": "",
    "arrowhead_bar": "",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "",
    "fontFamily": "",
    "addWatermark": "",
    "handDrawn": "",
    "normal": "",
    "code": "",
    "small": "",
    "medium": "",
    "large": "",
    "veryLarge": "ඉතා විශාල",
    "solid": "විශාල",
    "hachure": "මධ්‍යම",
    "zigzag": "",
    "crossHatch": "",
    "thin": "කෙට්ටු",
    "bold": "තද",
    "left": "වම",
    "center": "මැද",
    "right": "දකුණ",
    "extraBold": "ඉතා තද",
    "architect": "වාස්තුවේදීයා",
    "artist": "කලාකරු",
    "cartoonist": "සැකිලිරූකරු",
    "fileTitle": "ගොනු නාමය",
    "colorPicker": "පාට තෝරකය",
    "canvasColors": "",
    "canvasBackground": "කැන්වස පසුබිම",
    "drawingCanvas": "චිත්‍රක කැන්වසය",
    "layers": "ලේයර",
    "actions": "ක්‍රියාකාරකම",
    "language": "භාෂාව ",
    "liveCollaboration": "",
    "duplicateSelection": "",
    "untitled": "",
    "name": "නම",
    "yourName": "",
    "madeWithExcalidraw": "",
    "group": "",
    "ungroup": "",
    "collaborators": "",
    "showGrid": "",
    "addToLibrary": "",
    "removeFromLibrary": "",
    "libraryLoadingMessage": "",
    "libraries": "",
    "loadingScene": "",
    "align": "",
    "alignTop": "",
    "alignBottom": "",
    "alignLeft": "",
    "alignRight": "",
    "centerVertically": "",
    "centerHorizontally": "",
    "distributeHorizontally": "",
    "distributeVertically": "",
    "flipHorizontal": "",
    "flipVertical": "",
    "viewMode": "",
    "share": "",
    "showStroke": "",
    "showBackground": "",
    "toggleTheme": "",
    "personalLib": "",
    "excalidrawLib": "",
    "decreaseFontSize": "",
    "increaseFontSize": "",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "",
      "editEmbed": "",
      "create": "",
      "createEmbed": "",
      "label": "",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "",
      "exit": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "",
    "save": "",
    "saveAs": "",
    "load": "",
    "getShareableLink": "",
    "close": "",
    "selectLanguage": "",
    "scrollBackToContent": "",
    "zoomIn": "",
    "zoomOut": "",
    "resetZoom": "",
    "menu": "",
    "done": "",
    "edit": "",
    "undo": "",
    "redo": "",
    "resetLibrary": "",
    "createNewRoom": "",
    "fullScreen": "",
    "darkMode": "",
    "lightMode": "",
    "zenMode": "",
    "objectsSnapMode": "",
    "exitZenMode": "",
    "cancel": "",
    "clear": "",
    "remove": "",
    "embed": "",
    "publishLibrary": "",
    "submit": "",
    "confirm": "",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "",
    "errorRemovingFromLibrary": "",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "invalidSVGString": "",
    "cannotResolveCollabServer": "",
    "importLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "image": "",
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "library": "",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": ""
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": ""
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "element": "",
    "elements": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "title": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": ""
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
